export enum FeedManagementAdditionalField {
    SHOWS = 'shows',
    COVERAGE = 'coverage',
    ACCOUNTS_INVOLVED = 'accountsInvolved',
    SUBSCRIBERS = 'subscribers',
    PROMOTION = 'promotion',
}

export enum StatusFilter {
    ALL = 'all',
    MODERATION = 'moderation',
    DECLINED = 'declined',
    DRAFTS = 'drafts',
    WITHOUT_DRAFTS = 'without-drafts',
}

export type Option<TValue> = {
    displayName: string;
    value: TValue;
};
